import { getLoggedInUser } from "services/AuthService";
import PERMISSIONS from "rbac/Permissions.json";

import { AgentWorkspaceConstants } from "lookup/AgentWorkspaceConstants";
import { isCollectionNullOrEmpty } from "./UtilityService";

export function isLoggedInUserAWAdmin() {
  return getLoggedInUser()?.authorities?.includes(PERMISSIONS.PERM_AW_EXTENDED_ACCESS);
}

export function isLoggedInUserAWUser() {
  const user = getLoggedInUser();
  return user?.authorities?.some((authority) =>
    [PERMISSIONS.PERM_AW_MANAGE].includes(
      authority
    )
  ) || false;
}

export function isLoggedInUserAIAdmin() {
  return getLoggedInUser()?.authorities?.includes(PERMISSIONS.PERM_AW_SCHEDULE_AI_CALL);
}

export function isLoggedInUserBioSimilarUser() {
  return getLoggedInUser()?.authorities?.includes(PERMISSIONS.PERM_BIOSIMILAR_ACCESS);
}

export function isOwnedByLoggedInUser(callGroupData) {
  const user = getLoggedInUser();
  return callGroupData != null && user != null
    ? callGroupData.claimerUuid === user.uuid
    : false;
}

export function isOwnedByAnyone(callGroupData) {
  return callGroupData.claimerName !== null;
}

export function goBackIfCallGroupClosed(data, navigate, onExhausted) {
  const inProgressData = data.filter((x) =>
    AgentWorkspaceConstants.IN_PROGRESS_STATUSES.includes(x.status)
  );
  if (inProgressData.length <= 1) {
    if (typeof onExhausted === "function") {
      onExhausted();
    } else {
      redirectToListingPage(navigate);
    }
  }
}

export function redirectToListingPage(navigate) {

  if (window.history.length > 2) {
    navigate(-1);
  } else {
    navigate("/agent-workspace/list");
  }
}

export function extractStatusFilterForDetailsPage(status) {
  if (
    status instanceof Array &&
    (isCollectionNullOrEmpty(status) || status.every((s) => s === "ALL"))
  ) {
    return null;
  } else {
    return status;
  }
}

export function isLoggedInUserAWSConnectAgent() {
  return getLoggedInUser()?.authorities?.includes(PERMISSIONS.PERM_AW_AWS_CONNECT);
}

/**
 * Whether the logged-in user should use the agent next-call-group flow.
 * Requires the Statsig flag to be on and the user to not be an AW admin
 * ({@code PERM_AW_EXTENDED_ACCESS}); admins keep the Call Group List.
 *
 * @param {boolean} isFlagEnabled value from {@code useFeatureFlag} / PlatformFeatureFlagService
 * @returns {boolean}
 */
export function shouldUseAgentNextCallGroupFlow(isFlagEnabled) {
  if (!isFlagEnabled || !getLoggedInUser()) {
    return false;
  }
  return !isLoggedInUserAWAdmin();
}

/**
 * Primary call-groups screen for AGWS: filters for agent next-flow users, list otherwise.
 */
export function getAgentWorkspaceCallGroupsPath(isFlagEnabled) {
  return shouldUseAgentNextCallGroupFlow(isFlagEnabled)
    ? AgentWorkspaceConstants.AGENT_NEXT_CALL_GROUP_FILTER_PATH
    : "/agent-workspace/list";
}
